<template>
  <div class="Payment">
    <div class="sr">
      <div class="sr_title flex_row_between">
        <div class="flex_row">购买设备名称型号：
<!--          <div style="color: #000000; font-size: 0.16rem">{{paymentStr.title}}</div>-->
          <el-select v-model="paymentStr.paymentId" @change="selectChangeMethod" placeholder="请选择">
            <el-option
                v-for="item in paymentList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="flex_row">选择版本：
          <el-select v-model="paymentStr.applyVersion" @change="selectChangeMethod" placeholder="请选择">
            <el-option
                v-for="item in dropdownData"
                :key="item.keys"
                :label="item.value"
                :value="item.keys">
            </el-option>
          </el-select>
        </div>
        <div class="flex_row">价格：<div style="color: #FF0000; font-size: 0.16rem">￥{{paymentStr.price * paymentStr.number}}</div></div>
        <div class="flex_row" style="margin-right: 1.24rem">数量：
          <div class="sr_title_info">
            <div class="left" @click="reduceClick" style="cursor: pointer">-</div>
            <div class="center">{{paymentStr.number}}</div>
            <div class="right" style="cursor: pointer"  @click="paymentStr.number++">+</div>
          </div>
        </div>
      </div>
      <div class="sr_body">
        <div class="company">
          <div class="cp_title">
            <span>公司信息</span>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row">
              <div class="item_info">公司名称</div>
              <div class="item_input flex_row">
                <input type="text" v-model="ApplyName" required="required" placeholder="请输入公司名称">
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">手机号码</div>
              <div class="item_input flex_row">
                <input class="text" type="tel" v-model="ApplyTel" maxlength="11" placeholder="请输入手机号码" @blur="checkPhone(ApplyTel,true)">
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">联系人</div>
              <div class="item_input flex_row">
                <input class="text" type="text" v-model="ApplyPerson" placeholder="请输入联系人">
              </div>
            </div>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row" style="position:relative;">
              <div class="item_info">地区（省/市）</div>
              <div class="item_input flex_row">
                <input class="text" type="text" v-model="ApplyRegion" readonly="readonly" placeholder="请输入地区（省/市）" @click="isShow=!isShow">
              </div>
              <div class="divwrap" style="left: 30%; position: absolute;top: 0.88rem;font-size: 0.14rem;" v-show="isShow">
                <div class="mask" style="width: 100vw; min-width: 1024px;height: 100vh; background: rgb(0,0,0, 0.3);position: fixed;left: 0;top:0;z-index: -1" @click="isShow=false"></div>
                <v-distpicker type="mobile" style="height: 1.5rem; background: #FFFFFF" @selected='regionSelect($event,true)' hide-area>
                </v-distpicker>
              </div>
            </div>

            <div class="cp_item flex_row">
              <div class="item_info">地址</div>
              <div class="item_input flex_row">
                <input class="text" type="text" v-model="ApplyAddress" placeholder="请输入地址">
              </div>
            </div>
            <div class="cp_item flex_row">
            </div>
          </div>
          <div class="cp_items flex_row">
            <div class="cp_item flex_row">
              <div class="item_info">营业执照</div>
              <div class="upfile_content flex_row" style="flex: 1">
                <div class="fileBox flex_row">
                    <span class="fileinput-button flex_row" style="width: 0.5rem; height: 0.5rem; background-size: 0.5rem auto;">
                      <el-image
                          v-show="isBusiness"
                          style="width: 0.5rem; height: 0.5rem"
                          :src="srcBusiness"
                          fit="cover">
                      </el-image>
                      <input type="file" style="width: 0.5rem;height: 0.5rem;" @change="getFileProcess($event, 'business')">
                    </span>
                </div>
                <div class="fileBox-word" style="height: 0.1rem; line-height: 0.1rem; color: #B6B6B6; font-size: 0.12rem;">（点击上传）</div>
              </div>
            </div>
            <div class="cp_item flex_row">
              <div class="item_info">公司Logo</div>
              <div class="upfile_content flex_row" style="flex: 1">
                <div class="fileBox flex_row">
                    <span class="fileinput-button flex_row" style="width: 0.5rem; height: 0.5rem; background-size: 0.5rem auto;">
                      <el-image
                          v-show="isLogo"
                          style="width: 0.5rem; height: 0.5rem"
                          :src="srcLogo"
                          fit="cover">
                      </el-image>
                      <input type="file" style="width: 0.5rem;height: 0.5rem;" @change="getFileProcess($event,'logo')">
                    </span>
                </div>
                <div class="fileBox-word" style="height: 0.1rem; line-height: 0.1rem; color: #B6B6B6; font-size: 0.12rem;">（点击上传）</div>
              </div>
            </div>
            <div class="cp_item flex_row">
            </div>
          </div>
        </div>
        <div class="store">
          <div class="store_top flex_row">
            <div class="se_title">
              <span>门店信息</span>
            </div>
            <el-button class="inform" @click="add">新增门店信息</el-button>
          </div>
          <div class="store_content">
            <div class="content_top flex_row">
              <div>门店名称</div>
              <div>手机</div>
              <div>联系人</div>
              <div>地区（省/市）</div>
              <div>详细地址</div>
              <div>门头照片</div>
              <div style="flex: 1">删除</div>
            </div>
            <div class="content_body">
              <div class="store_items flex_row" :style="{'background':index%2==0?'#FFF':'#DDD'}" v-for="(item, index) in ListShop">
                <div class="store_item flex_row">
                  <input type="text" v-model="item.ApplyName" placeholder="请输入店面名称" />
                </div>
                <div class="store_item flex_row">
                  <input type="tel" v-model="item.ApplyTel" maxlength="11"  placeholder="请输入店面手机号码" @blur="checkPhone(item.ApplyTel,false, index)">
                </div>
                <div class="store_item flex_row">
                  <input type="text" v-model="item.ApplyPerson" placeholder="请输入店联系人">
                </div>
                <div class="store_item flex_row" style="position:relative;">
                  <input type="text" v-model="item.ApplyRegion" readonly="readonly" placeholder="请输入店面省/市" @click="showDivWrap(index)">
                  <div class="divwrap" v-show="item.isShow" style="position: fixed; left: 0;bottom: 0;width: 100%;font-size: 0.25rem;">
                    <div class="mask" style="width: 100vw; min-width: 1024px; height: 100vh; background: rgb(0,0,0, 0.3);position: fixed;left: 0;top:0;z-index: -1" @click="item.isShow=false">
                    </div>
                    <v-distpicker type="mobile" style="background: #FFFFFF;height: 40vh" @selected='regionSelect($event,false, index)' hide-area>
                    </v-distpicker>
                  </div>
                </div>
                <div class="store_item flex_row">
                  <input type="text" v-model="item.ApplyAddress" placeholder="请输入店面地址">
                </div>
                <div class="store_item flex_row">
                  <div class="upfile_content flex_row" >
                    <div class="fileBox flex_row">
                    <span class="fileinput-button flex_row" style="width: 0.4rem; height: 0.4rem; background-size: 0.4rem auto;">
                      <el-image
                          v-show="item.isStore"
                          style="width: 0.4rem; height: 0.4rem"
                          :src="item.srcStore"
                          fit="cover">
                      </el-image>
                      <input type="file" style="width: 0.4rem;height: 0.4rem;" @change="getFileProcess($event,'',index)">
                    </span>
                    </div>
                    <div class="fileBox-word" style="height: 0.065rem; line-height: 0.065rem;color: #B6B6B6; font-size: 0.11rem;">（点击上传）</div>
                  </div>
                </div>
                <div class="store_item flex_row" style="flex: 1">
                  <button class="delect flex_row" @click="delectClick" :data-index="index">
                    <img src="@/assets/img/delect.png" :data-index="index" alt="">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_row">
          <el-button class="submit" @click="submit">提交</el-button>
          <el-button class="submit" @click="cancel">返回</el-button>
        </div>
      </div>
    </div>
    <img class="back" src="@/assets/img/informate.jpg" alt="">
  </div>
</template>

<script>
import VDistpicker from "@/components/v-distpicker/Distpicker";
import bf from "@/publicFn/baseFn"
export default {
  name: "Payment",
  components: {
    VDistpicker
  },
  data() {
    return {
      mg: false,
      isShow: false,

      isBusiness: false,
      srcBusiness: '',
      businessId: '',
      isLogo: false,
      srcLogo: '',
      logoId: '',

      ApplyName: '',
      ApplyId: '',
      ApplyTel: "",
      ApplyPerson: "",
      ApplyRegion: '',
      ApplyProvinceId: "",
      ApplyProvince: "",
      ApplyCityId: "",
      ApplyCity: "",
      ApplyAddress: "",
      ListShop: [],
      paymentList: [
        {
          id: 0,
          title: '智慧视典2.0',
          price: 39000
        },
        {
          id: 1,
          title: '智慧视典 3.0',
          price: 68000
        },
        {
          id: 2,
          title: '智慧视典 4.0',
          price: 150000
        },
        {
          id: 3,
          title: '智慧视典 5.0',
          price: 98000
        },
        {
          id: 4,
          title: '智慧视典 6.0',
          price: 200000
        },
      ],
      paymentStr: {
      },
      options: [{
        title: '选项1',
        price: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      dropdownData: [
        {keys: 0,value: '眼镜店版'},
        {keys: 1, value: '视光中心版'},
        {keys: 2, value: '门诊版'},
        {keys: 3, value: '医院版'}
      ]
    }
  },
  created() {
    if(this.$route.query.payment) {
      let payment = this.$route.query.payment;
      if(payment > 0 && payment <= this.paymentList.length) {
        // this.paymentStr = this.paymentList[payment - 1];
        this.$set(this.paymentStr, 'paymentId', this.paymentList[payment - 1].id);
        this.$set(this.paymentStr, 'applyVersion', '');
        this.$set(this.paymentStr, 'title', this.paymentList[payment - 1].title);
        this.$set(this.paymentStr, 'price', this.paymentList[payment - 1].price);
        this.$set(this.paymentStr, 'number', 1);
      }
      else {
        this.cancel();
      }
    }
  },
  methods: {
    selectChangeMethod(res) {
      this.paymentStr.price = this.paymentList[res].price;
      this.paymentStr.title = this.paymentList[res].title;
      this.paymentStr.number = 1;
    },
    close() {
      this.mg = !this.mg
    },
    reduceClick() {
      if(this.paymentStr.number <= 1) return;
      this.paymentStr.number--;
    },
    checkData() {

    },

    cancel() {
      this.$router.go(-1);
    },

    submit() {
      console.log(this.paymentList)
      if(!this.ApplyName)  {
        this.$alert('公司名称为空', '提示');
        return;
      }
      if(!this.ApplyTel)  {
        this.$alert('公司手机号码为空', '提示');
        return;
      }
      if(!this.ApplyPerson)  {
        this.$alert('联系人为空', '提示');
        return;
      }
      if(!this.ApplyRegion)  {
        this.$alert('省/市为空', '提示');
        return;
      }
      if(!this.ApplyAddress)  {
        this.$alert('详细地址为空', '提示');
        return;
      }
      if(!this.srcBusiness)  {
        this.$alert('请提交营业执照', '提示');
        return;
      }
      if(!this.srcLogo)  {
        this.$alert('请提交公司Logo', '提示');
        return;
      }
      if(this.ListShop.length <= 0)  {
        this.$alert('必须添加门店信息喔', '提示');
        return;
      }
      for(let i = 0; i < this.ListShop.length; i++) {
        if(!this.ListShop[i].ApplyName || !this.ListShop[i].ApplyTel || !this.ListShop[i].ApplyPerson || !this.ListShop[i].ApplyRegion || !this.ListShop[i].ApplyAddress || !this.ListShop[i].srcStore) {
          this.$alert('门店信息有空', '提示');
          return;
        }
      }
      let lo = this.$loading({
        text: '注册中...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this._api.userCurdApi.ApplyInsert(this.ApplyId, this.ApplyName, this.ApplyTel, this.ApplyPerson, this.ApplyProvinceId, this.ApplyProvince, this.ApplyCityId, this.ApplyCity, this.ApplyAddress, this.ListShop, this.ApplyVersion)
          .then(res => {
            lo.close()
            if (res.InsertResult !== 0) {
              this.$store.commit('bases/upApplyId', res.Id)
              this.$store.commit('bases/upApplyTel', this.ApplyTel)
              this.$alert('注册成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.go(-1);
                }
              });
            }else {
              if(res.msg == 'Exists') {
                this.$alert('手机号已被注册过！', '提示')
              }
              else {
                this.$alert(res.msg, '提示')
              }
            }
          })
    },

    add() {
      this.ListShop.push({});
    },

    regionSelect(res, type, index = 0) {
      let province = res.province.value.AreaName;
      let ApplyProvinceId = res.province.value.AreaId;
      let city = res.city.value.AreaName;
      let ApplyCityId = res.city.value.AreaId;
      if(type) {
        this.ApplyRegion = province + '/' + city;
        this.ApplyProvince = province;
        this.ApplyProvinceId = ApplyProvinceId;
        this.ApplyCity = city;
        this.ApplyCityId = ApplyCityId;
        this.isShow = false;
      }
      else {
        this.ListShop[index].ApplyRegion = province + '/' + city;
        this.ListShop[index].ApplyProvince = province;
        this.ListShop[index].ApplyProvinceId = ApplyProvinceId;
        this.ListShop[index].ApplyCity = city;
        this.ListShop[index].ApplyCityId = ApplyCityId;
        this.ListShop[index].isShow = false;
      }
    },

    getImageLimit(fileSize) {
      let limit =   fileSize / 1024 / 1024;
      if(limit > 5) {
        return true;
      } else {
        return false;
      }
    },

    getFileProcess (e, type, index = 0) {//附件预览----合同及其他扫描件
      let _this = this;
      let files = e.target.files[0];
      let ufType = 'CompanyLogo';
      const isIMAGE = (files.type === 'image/jpeg' || files.type === 'image/png'|| files.type === 'image/gif');
      if (!isIMAGE) {
        this.$message.error('上传文件只能是图片格式!');
        return false;
      }
      if(this.getImageLimit(files.size)) {
        let message = '';
        if(type == 'business') {
          message = '图片过大，请重新提交营业执照'
        }
        else if(type == 'logo') {
          message = '图片过大，请重新提交公司Logo'
        }
        else {
          message = '图片过大，请重新提交门头照片'
        }
        this.$alert(message, '提示');
        return;
      }
      let splitType = files.name.split('.');
      let srcType = '.' + splitType[splitType.length - 1];
      if (!e || !window.FileReader) return  // 看支持不支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      let flag = false;
      let deleteId = '';
      reader.onloadend = function () {
        if(type == 'business') {
          if(_this.srcBusiness)
          {
            flag = true;
            deleteId = _this.businessId;
          }
          _this.srcBusiness = this.result
          _this.isBusiness = true;
          ufType= 'CompanyLic';
        }
        else if(type == 'logo') {
          if(_this.srcLogo) {
            flag = true;
            deleteId = _this.logoId;
          }
          _this.srcLogo = this.result
          _this.isLogo = true;
          ufType= 'CompanyLogo';
        }
        else {
          if(_this.ListShop[index].srcStore) {
            flag = true;
            deleteId = _this.ListShop[index].storeId;
          }
          _this.ListShop[index].srcStore = this.result
          _this.ListShop[index].isStore = true;
          _this.setData(index);
          ufType= 'ShopPic';
        }

        let UFReId = bf.getGuid();
        if(type == 'business' || type == 'logo') {
          if(!_this.ApplyId) {
            _this.ApplyId = UFReId;
          }
          UFReId = _this.ApplyId;
        }
        else {
          if(!_this.ListShop[index].ApplyId) {
            _this.ListShop[index].ApplyId = UFReId;
          }
          UFReId = _this.ListShop[index].ApplyId
        }
        if(flag) {
          _this._api.userCurdApi.UploadFileDeleteById(deleteId).then(res => {
            //删除成功
            if(res.DeleteByIdReturn !== 0){
              //加载图片
              _this.upLoadFile(type, this.result, UFReId, 'Apply', srcType, ufType, 'OSSPrivate',index)
            }
            else {
              // _this.alert('删除失败','提示')
              console.log('删除失败');
            }
          })
        } else {
          _this.upLoadFile(type, this.result, UFReId, 'Apply', srcType, ufType, 'OSSPrivate',index);
        }

      }
    },

    upLoadFile(type, result, UFReId, Apply, srcType, ufType, OSSPrivate,index=0) {
      let _this = this;
      this._api.userCurdApi.UploadFileUpload(result.split(',')[1], UFReId, Apply, srcType, ufType, OSSPrivate)
          .then(res => {
            if(res.msg == 'Success') {
              if(type == 'business') {
                _this.businessId = res.Id
              }
              else if(type == 'logo') {
                _this.logoId = res.Id
              }
              else {
                _this.ListShop[index].storeId = res.Id
              }
            }
          })
    },

    setData(index) {
      this.$set(this.ListShop,index, {
        ApplyRegion: this.ListShop[index].ApplyRegion,
        ApplyProvinceId: this.ListShop[index].ApplyProvinceId,
        ApplyProvince: this.ListShop[index].ApplyProvince,
        ApplyCityId: this.ListShop[index].ApplyCityId,
        ApplyCity: this.ListShop[index].ApplyCity,
        isShow: this.ListShop[index].isShow,
        ApplyName: this.ListShop[index].ApplyName,
        ApplyTel: this.ListShop[index].ApplyTel,
        ApplyPerson: this.ListShop[index].ApplyPerson,
        ApplyAddress: this.ListShop[index].ApplyAddress,
        isStore: this.ListShop[index].isStore,
        srcStore: this.ListShop[index].srcStore,
        storeId: this.ListShop[index].storeId,
        ApplyId: this.ListShop[index].ApplyId
      })
    },

    showDivWrap(index) {
      this.ListShop[index].isShow=!this.ListShop[index].isShow;
      this.setData(index)
    },

    checkPhone(iphone, type, index = 0) {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(iphone))) {
        //alert("手机号码有误，请重填");
        this.$alert('手机号码有误，请重填', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            if(type) {
              this.ApplyTel = '';
            }
            else {
              this.ListShop[index].ApplyTel = '';
            }
          }
        });
      }
    },

    delectClick(e) {
      let index = e.target.dataset.index;
      this.ListShop.splice(index,1);
      console.log(this.ListShop)
    }

  }
}
</script>

<style scoped lang="scss">
.Payment {
  width: 100vw;
  min-width: 1024px;
  height: 100vh;
  position: relative;
  .flex_row_between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .back {
    width: 100%;
  }
  ::v-deep .el-input__inner {
    line-height: 0.45rem;
    height: 0.45rem;
  }
  /* 下面设置右侧按钮居中 */
  ::v-deep .el-input__suffix-inner {
    display: inline-block;
    height: 100%;
  }
  ::v-deep .el-input__icon {
    line-height: inherit;
  }

  input::-webkit-input-placeholder  { /* WebKit browsers */
    color: #B6B6B6;
  }
  input:-moz-placeholder  { /* Mozilla Firefox 4 to 18 */
    color: #B6B6B6;
    font-size: 1.8rem;
  }
  input::-moz-placeholder{ /* Mozilla Firefox 19+ */
    color: #B6B6B6;
  }
  input:-ms-input-placeholder{ /* Internet Explorer 10+ */
    color: #B6B6B6;
  }
  //点击上传的样式 start
  .upfile_content { //flex_row style="width: 60%"
    justify-content: flex-start;
    .fileBox{//flex_row
      justify-content: flex-start;
      .fileinput-button { //flex_row  style="width: 1.6rem; height: 1.6rem; background-size: 1.6rem auto;"
        float: left;
        position: relative;
        display: inline-block;
        overflow: hidden;
        background: url(../../../assets/img/gw_add.png) no-repeat;
        background-position: center center;

        input {
          position: absolute;
          left: 0px;
          top: 0px;
          opacity: 0;
          -ms-filter: 'alpha(opacity=0)';
        }
      }
    }
    .fileBox-word{ // style="height: 1.6rem; line-height: 1.6rem; color: #B6B6B6; font-size: 0.48rem;"

    }
  }
  //点击上传的样式 end
  .sr {
    position: absolute;
    width: 96%;
    margin: 2% 2%;
    .sr_title {
      color: #808080;
      padding: 0.1rem 0.21rem;
      text-align: left;
      font-weight: 500;
      font-size: 0.14rem;
      background: rgba(255,255,255,0.83);
      .sr_title_info {
        display: flex;
        font-size: 0.16rem;
        div {
          padding: 0.05rem 0.12rem;
          border: 1px solid #808080;
        }
        .left {
          border-top-left-radius: 50%;
          border-bottom-left-radius: 50%;
        }
        .center {
          border-left: 0;
          border-right: 0;
        }
        .right {
          border-top-right-radius: 50%;
          border-bottom-right-radius: 50%;
        }
      }
    }
    .sr_body {
      margin-top: 0.03rem;
      background: rgba(255,255,255,0.83);
      .company,.store {
        padding-top: 0.17rem;
        .cp_title,.se_title {
          text-align: left;
          span {
            font-weight: bold;
            background: #97CBFF;
            padding: 0.07rem 0.33rem;
            font-size: 0.13rem;
            color: #000000;
          }
        }
        .cp_items {
          margin-top: 0.13rem;
          .cp_item {
            flex: 1;
            .item_info {
              margin-left: 0.28rem;
              text-align: left;
              width: 1.5rem;
              font-size: 0.12rem;
              font-weight: bold;
              color: #808080;
            }
            .item_input {
              flex: 1;
              justify-content: flex-start;
              input {
                padding: 0.01rem 0;
                border: none;
                outline: none;
                background: transparent;
                font-size: 0.12rem;
                //font-weight: bold;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }

            }
            .item_content {
              justify-content: flex-start;
              .fileBox{
                justify-content: flex-start;
                .fileinput-button {
                  float: left;
                  position: relative;
                  display: inline-block;
                  overflow: hidden;
                  background: url(../../../assets/img/gw_add.png) no-repeat;
                  background-size: 0.4rem auto;
                  background-position: center center;

                  input {
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    opacity: 0;
                    -ms-filter: 'alpha(opacity=0)';
                  }
                }
              }
              .fileBox-word{
                height: 0.4rem;
                line-height: 0.4rem;
                color: #B6B6B6;
                font-size: 0.12rem;
              }
            }
          }
        }
      }
      .store {
        .store_top {
          justify-content: space-between;
          .inform {
            margin-right: 0.28rem;
            padding: 0.09rem 0.18rem;
            border: 0.01rem solid #FDA100;
            border-radius: 0.11rem;
            font-size: 0.13rem;
            font-weight: 500;
          }
        }
        .store_content {
          width: 98%;
          margin: 0.2rem auto 0;
          .content_top {
            background: #DDDDDD;
            div {
              padding: 0.12rem 0;
              flex: 2;
              font-size: 0.11rem;
              font-weight: 500;
            }
          }
          .content_body {
            height: 1.75rem;
            overflow-y: auto;
            //overflow: hidden;
            .store_items {
              padding: 0.08rem 0;
              background: #fff;
              .store_item {
                flex: 2;
                input {
                  padding: 0.01rem 0;
                  text-align: center;
                  width: 100%;
                  border: none;
                  outline: none;
                  background: transparent;
                  font-size: 0.12rem;
                  overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;
                }
                .delect {
                  width: 0.3rem;
                  height: 0.3rem;
                  border: none;
                  border-radius: 0.02rem;
                  padding: 0.08rem;
                  color: #FFF;
                  background-color: #F56C6C;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
            .back {
              background: #DDDDDD;
            }
          }
        }
      }
      .submit {
        margin: 0.23rem;
        padding: 0.1rem 0.34rem;
        background: #7CBCFD;
        box-shadow: 0px 0.04rem 0.04rem 0px rgba(11, 3, 6, 0.11);
        border-radius: 0.11rem;
        font-size: 0.17rem;
        //font-weight: bold;
        color: #FFFFFF;
      }
    }

    //修改地区选择框样式开始

    .divwrap {
      z-index: 999;
      overflow-y: auto;
      background: #fff;
      //overflow: hidden;
    }
    //修改地区选择框样式结束

  }
}
</style>